import { generatePath } from "react-router-dom";

import { ROUTES } from "@/constants";

import getMediaFileConnectionPath, { type MediaFileLinkTarget } from "./getMediaFileConnectionPath";

export type MediaFilePreviewPathOptions = {
  readonly id: string;
  readonly linkTarget?: MediaFileLinkTarget;
};

export default function getMediaFilePreviewPaths({ id, linkTarget }: MediaFilePreviewPathOptions) {
  return {
    pagePath: generatePath(ROUTES.mediaFile, { id }),
    relatedEntityPath: linkTarget ? getMediaFileConnectionPath(linkTarget) : undefined,
  };
}
